// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"225":"af6e41de","838":"0cf02d0b"}[chunkId] + ".js";
};